import React, { useState } from 'react';

const InviteOnlyRegistration = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [inviteCode, setInviteCode] = useState('');
  const [isValidating, setIsValidating] = useState(false);
  const [validationMessage, setValidationMessage] = useState('');
  const [isValidCode, setIsValidCode] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    emailAddress: '',
    company: '',
    password: '',
    acceptedTerms: false
  });

  const validateInviteCode = async (code) => {
    if (!code || code.length < 8) {
      setValidationMessage('Please enter a valid invitation code');
      setIsValidCode(false);
      return;
    }

    setIsValidating(true);
    setValidationMessage('');

    try {
      const response = await fetch(`/api/validate-invite?code=${encodeURIComponent(code)}`);
      const result = await response.json();
      
      if (result.valid) {
        setValidationMessage('✓ Invitation code validated successfully!');
        setIsValidCode(true);
      } else {
        setValidationMessage('Invalid invitation code. Please check and try again.');
        setIsValidCode(false);
      }
    } catch (error) {
      console.error('Validation error:', error);
      setValidationMessage('Unable to validate code. Please try again.');
      setIsValidCode(false);
    } finally {
      setIsValidating(false);
    }
  };

  const handleInviteSubmit = (e) => {
    e.preventDefault();
    if (isValidCode) {
      setCurrentStep(2);
    } else {
      validateInviteCode(inviteCode);
    }
  };

const handleRegistrationSubmit = async (e) => {
  e.preventDefault();
  
  if (!formData.acceptedTerms) {
    alert('Please accept the Terms and Conditions');
    return;
  }

  try {
    const response = await fetch('/api/create-user', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        inviteCode,
        firstName: formData.firstName,
        lastName: formData.lastName,
        emailAddress: formData.emailAddress,
        company: formData.company,
        password: formData.password
      })
    });
// Track the registration
try {
  await fetch('/api/mark-invite-used', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      inviteCode,
      userDetails: {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.emailAddress,
        company: formData.company
      }
    }),
  });
} catch (trackingError) {
  console.error('Registration tracking failed:', trackingError);
}
    const result = await response.json();

    if (response.ok) {
      // Use the sign-in token that your API already creates
    window.location.replace(`/sign-in?sign_in_token=${result.signInToken}`);
    } else {
      alert(result.error || 'Registration failed. Please try again.');
    }
    
  } catch (err) {
    console.error('Registration error:', err);
    alert('Registration failed. Please try again.');
  }
};

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  return (
   <div style={{
  minHeight: '100vh',  // Changed from height to minHeight
  width: '100vw',
  background: 'linear-gradient(135deg, #157DEC 0%, #1054a8 100%)',
  fontFamily: 'Century Gothic, sans-serif',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'stretch',
  padding: '10px',
  boxSizing: 'border-box'
}}>
      
      <div style={{
        width: '100%',
        maxWidth: '1200px',
        display: 'grid',
        gridTemplateRows: 'auto 1fr auto',
        gridTemplateAreas: '"header" "main" "footer"'
      }}>
      
        {/* Header - EXACTLY from Landing Page */}
        <div style={{
          gridArea: 'header',
          background: 'white',
          padding: '15px 35px',
          borderRadius: '10px',
          border: '5px solid black',
          textAlign: 'center',
          boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
        }}>
          
          <div style={{ 
            display: 'flex', 
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '6px'
          }}>
            <div style={{ width: '140px' }}></div>
            
            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', zIndex: 1 }}>
              <svg 
                viewBox="0 0 360 90" 
                xmlns="http://www.w3.org/2000/svg"
                style={{ width: '661px', height: '120px' }}
              >
                <defs>
                  <linearGradient id="brandBlue" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{stopColor:'#157DEC', stopOpacity:1}} />
                    <stop offset="100%" style={{stopColor:'#1054a8', stopOpacity:1}} />
                  </linearGradient>
                  <linearGradient id="accentBlue" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{stopColor:'#1054a8', stopOpacity:1}} />
                    <stop offset="100%" style={{stopColor:'#0c4389', stopOpacity:1}} />
                  </linearGradient>
                  <linearGradient id="lightBlue" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" style={{stopColor:'#3b94f0', stopOpacity:1}} />
                    <stop offset="100%" style={{stopColor:'#157DEC', stopOpacity:1}} />
                  </linearGradient>
                  
                  <filter id="energyGlow" x="-50%" y="-50%" width="200%" height="200%">
                    <feGaussianBlur stdDeviation="4" result="coloredBlur"/>
                    <feMerge> 
                      <feMergeNode in="coloredBlur"/>
                      <feMergeNode in="SourceGraphic"/>
                    </feMerge>
                  </filter>
                  
                  <filter id="sharpShadow" x="-20%" y="-20%" width="140%" height="140%">
                    <feDropShadow dx="3" dy="3" stdDeviation="0" floodColor="rgba(0,0,0,0.25)"/>
                  </filter>
                </defs>
                
                <path d="M 15 15 L 65 25 L 55 65 L 25 55 Z" fill="url(#brandBlue)" opacity="0.08" transform="rotate(12 40 40)"/>
                <circle cx="50" cy="50" r="25" fill="url(#lightBlue)" opacity="0.05"/>
                
                <g transform="translate(20, 22) skewX(-8)" filter="url(#sharpShadow)">
                  <rect x="6" y="16" width="26" height="20" fill="url(#brandBlue)" rx="3"/>
                  <path d="M 19 6 L 4 16 L 34 16 Z" fill="url(#accentBlue)"/>
                  <rect x="12" y="26" width="7" height="10" fill="#ffffff" rx="2"/>
                  <circle cx="17" cy="31" r="1.2" fill="url(#lightBlue)"/>
                  <rect x="22" y="20" width="7" height="5" fill="#ffffff" rx="1"/>
                  <rect x="8" y="20" width="4" height="4" fill="#ffffff" rx="1"/>
                  <path d="M 19 8 L 15 12 L 23 12 Z" fill="#ffffff" opacity="0.9"/>
                </g>
                
                <g transform="translate(50, 28) skewX(5)" filter="url(#energyGlow)">
                  <rect x="0" y="0" width="20" height="26" fill="url(#lightBlue)" rx="4"/>
                  <rect x="2" y="2" width="16" height="7" fill="#000000" rx="2"/>
                  <text x="10" y="7" textAnchor="middle" fill="#157DEC" fontFamily="JetBrains Mono, monospace" fontSize="3.5" fontWeight="700">+18.2%</text>
                  
                  <g fill="#ffffff">
                    <rect x="3" y="11" width="3" height="2.5" rx="0.5"/>
                    <rect x="7" y="11" width="3" height="2.5" rx="0.5"/>
                    <rect x="11" y="11" width="3" height="2.5" rx="0.5"/>
                    <rect x="15" y="11" width="3" height="2.5" rx="0.5" fill="url(#accentBlue)"/>
                    
                    <rect x="3" y="14.5" width="3" height="2.5" rx="0.5"/>
                    <rect x="7" y="14.5" width="3" height="2.5" rx="0.5"/>
                    <rect x="11" y="14.5" width="3" height="2.5" rx="0.5"/>
                    <rect x="15" y="14.5" width="3" height="2.5" rx="0.5" fill="url(#accentBlue)"/>
                    
                    <rect x="3" y="18" width="3" height="2.5" rx="0.5"/>
                    <rect x="7" y="18" width="3" height="2.5" rx="0.5"/>
                    <rect x="11" y="18" width="3" height="2.5" rx="0.5"/>
                    <rect x="15" y="18" width="3" height="5" rx="0.5" fill="url(#brandBlue)"/>
                    
                    <rect x="3" y="21.5" width="7" height="2.5" rx="0.5"/>
                    <rect x="11" y="21.5" width="3" height="2.5" rx="0.5"/>
                  </g>
                  
                  <circle cx="17" cy="3.5" r="1" fill="url(#brandBlue)" opacity="0.9"/>
                </g>
                
                <g transform="translate(-5, 0)">
                  <g transform="translate(95, 0)">
                    <text x="0" y="22" fontFamily="Poppins, system-ui, sans-serif" fontSize="20" fontWeight="800" fill="#1f2937">
                      <tspan fill="url(#brandBlue)">The Buy</tspan><tspan fill="url(#brandBlue)"> to </tspan><tspan fill="url(#brandBlue)">Let</tspan>
                    </text>
                    <text x="0" y="44" fontFamily="Poppins, system-ui, sans-serif" fontSize="20" fontWeight="800" fill="#1f2937">
                      Calculator <tspan fill="url(#brandBlue)">Company</tspan>
                    </text>
                    
                    <text x="0" y="63" fontFamily="Inter, system-ui, sans-serif" fontSize="9" fontWeight="500" fontStyle="italic" fill="url(#brandBlue)" letterSpacing="0.5px">
                      Affordability Guidance for Brokers
                    </text>
                    
                    <rect x="0" y="68" width="60" height="2" fill="url(#brandBlue)" rx="1" opacity="0.7"/>
                  </g>
                </g>
                
                <g opacity="0.6">
                  <path d="M 320 20 L 330 15 L 340 25 L 325 30 Z" fill="url(#accentBlue)"/>
                  <circle cx="315" cy="60" r="4" fill="url(#lightBlue)"/>
                  <rect x="330" y="70" width="8" height="8" fill="url(#brandBlue)" rx="2" transform="rotate(25 334 74)"/>
                </g>
                
                <path d="M 280 30 Q 290 25 300 30" stroke="url(#brandBlue)" strokeWidth="1.5" fill="none" opacity="0.4"/>
                <path d="M 285 65 Q 295 60 305 65" stroke="url(#accentBlue)" strokeWidth="1" fill="none" opacity="0.5"/>
              </svg>
            </div>
            
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column',
              gap: '8px',
              width: '140px'
            }}>
              <button style={{
                padding: '8px 12px',
                fontSize: '12px',
                background: 'white',
                color: '#157DEC',
                border: '2px solid black',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold',
                width: '100%',
                whiteSpace: 'nowrap'
              }}>
                Existing Users Login
              </button>
              
              <button style={{
                padding: '8px 12px',
                fontSize: '12px',
                background: '#157DEC',
                color: 'white',
                border: '2px solid black',
                borderRadius: '5px',
                cursor: 'pointer',
                fontWeight: 'bold',
                width: '100%'
              }}>
                Sign Up Now
              </button>
              
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                marginTop: '8px'
              }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.465 3.488" fill="#25D366"/>
                </svg>
                <a 
                  href="https://wa.me/447874401497"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ 
                    color: '#4a5568', 
                    fontSize: '14px',
                    fontWeight: 'bold',
                    textDecoration: 'none'
                  }}
                >
                  07874 401497
                </a>
              </div>
            </div>
          </div>
          
          <p style={{
            fontSize: '20px',
            color: 'black',
            fontWeight: 'bold',
            margin: 0,
            position: 'relative',
            zIndex: 2,
            textAlign: 'center'
          }}>
            Professional Access Registration - Invitation Only <span style={{ color: '#157DEC', fontSize: '20px', fontStyle: 'italic' }}>with exclusive access for verified brokers</span>
          </p>
        </div>

        {/* Main Content */}
        <div style={{
          gridArea: 'main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '10px 0'
        }}>
          
          {/* Step 1 */}
          {currentStep === 1 && (
            <div style={{
              background: 'white',
              padding: '20px',
              borderRadius: '8px',
              border: '3px solid black',
              textAlign: 'center',
              boxShadow: '0 3px 10px rgba(0,0,0,0.1)',
              maxWidth: '500px',
              width: '100%'
            }}>
              <h3 style={{ 
                fontSize: '18px', 
                fontWeight: 'bold', 
                color: '#157DEC',
                margin: '0 0 10px 0'
              }}>
                Step 1: Enter Your Invitation Code
              </h3>
              <p style={{ 
                fontSize: '14px', 
                color: '#4a5568',
                margin: '0 0 15px 0'
              }}>
                Professional brokers require a valid invitation code to access comprehensive affordability assessment tools
              </p>
              
              <div style={{ marginBottom: '15px' }}>
                <label style={{
                  display: 'block',
                  color: '#2d3748',
                  fontWeight: 'bold',
                  marginBottom: '5px',
                  textAlign: 'left',
                  fontSize: '12px'
                }}>
                  Invitation Code
                </label>
                <input
                  type="text"
                  value={inviteCode}
                  onChange={(e) => setInviteCode(e.target.value.toUpperCase())}
                  placeholder="Enter your invitation code"
                  disabled={isValidating}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: `2px solid ${isValidCode ? '#157DEC' : 'black'}`,
                    borderRadius: '5px',
                    fontSize: '14px',
                    boxSizing: 'border-box',
                    background: isValidCode ? '#f0f8ff' : 'white',
                    fontWeight: 'bold'
                  }}
                />
                {validationMessage && (
                  <div style={{
                    marginTop: '5px',
                    padding: '5px 10px',
                    borderRadius: '5px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    background: isValidCode ? '#d4edda' : '#f8d7da',
                    color: isValidCode ? '#155724' : '#721c24',
                    border: `1px solid ${isValidCode ? '#157DEC' : '#dc3545'}`
                  }}>
                    {validationMessage}
                  </div>
                )}
              </div>
              
              <button 
                onClick={handleInviteSubmit}
                disabled={isValidating || !inviteCode}
                style={{
                  width: '100%',
                  padding: '10px 20px',
                  fontSize: '12px',
                  background: '#157DEC',
                  color: 'white',
                  border: '2px solid black',
                  borderRadius: '5px',
                  cursor: (isValidating || !inviteCode) ? 'not-allowed' : 'pointer',
                  fontWeight: 'bold',
                  opacity: (isValidating || !inviteCode) ? 0.6 : 1,
                  marginBottom: '6px'
                }}
              >
                {isValidating ? 'Validating...' : isValidCode ? 'Continue to Registration' : 'Validate Invitation Code'}
              </button>

              <div style={{
                paddingTop: '10px',
                borderTop: '1px solid #e2e8f0',
                fontSize: '11px',
                color: '#4a5568'
              }}>
                <p style={{ margin: '0 0 5px' }}>Need an invitation code?</p>
                <a 
                  href="mailto:access@btlcc.co.uk?subject=Access%20Request"
                  style={{
                    color: '#157DEC',
                    textDecoration: 'underline',
                    fontWeight: 'bold'
                  }}
                >
                  Request access from our team
                </a>
              </div>
            </div>
          )}

          {/* Step 2 */}
          {currentStep === 2 && (
            <div style={{
              background: 'white',
              padding: '20px',
              borderRadius: '8px',
              border: '3px solid black',
              boxShadow: '0 3px 10px rgba(0,0,0,0.1)',
              maxWidth: '600px',
              width: '100%'
            }}>
              <h3 style={{ 
                fontSize: '18px', 
                fontWeight: 'bold', 
                color: '#157DEC',
                margin: '0 0 10px 0',
                textAlign: 'center'
              }}>
                Step 2: Create Your Account
              </h3>

              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '10px',
                marginBottom: '6px'
              }}>
                <div>
                  <label style={{
                    display: 'block',
                    color: '#2d3748',
                    fontWeight: 'bold',
                    marginBottom: '3px',
                    fontSize: '11px'
                  }}>
                    First Name *
                  </label>
                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '8px',
                      border: '2px solid black',
                      borderRadius: '5px',
                      fontSize: '12px',
                      boxSizing: 'border-box'
                    }}
                  />
                </div>
                <div>
                  <label style={{
                    display: 'block',
                    color: '#2d3748',
                    fontWeight: 'bold',
                    marginBottom: '3px',
                    fontSize: '11px'
                  }}>
                    Last Name *
                  </label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    required
                    style={{
                      width: '100%',
                      padding: '8px',
                      border: '2px solid black',
                      borderRadius: '5px',
                      fontSize: '12px',
                      boxSizing: 'border-box'
                    }}
                  />
                </div>
              </div>

              <div style={{ marginBottom: '10px' }}>
                <label style={{
                  display: 'block',
                  color: '#2d3748',
                  fontWeight: 'bold',
                  marginBottom: '3px',
                  fontSize: '11px'
                }}>
                  Email Address *
                </label>
                <input
                  type="email"
                  name="emailAddress"
                  value={formData.emailAddress}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '2px solid black',
                    borderRadius: '5px',
                    fontSize: '12px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div style={{ marginBottom: '10px' }}>
                <label style={{
                  display: 'block',
                  color: '#2d3748',
                  fontWeight: 'bold',
                  marginBottom: '3px',
                  fontSize: '11px'
                }}>
                  Company Name *
                </label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleInputChange}
                  required
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '2px solid black',
                    borderRadius: '5px',
                    fontSize: '12px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div style={{ marginBottom: '15px' }}>
                {/* Password Requirements Box */}
                <div style={{
                  backgroundColor: '#f0f8ff',
                  border: '2px solid #157DEC',
                  borderRadius: '8px',
                  padding: '12px',
                  marginBottom: '10px',
                  fontFamily: 'Century Gothic, sans-serif'
                }}>
                  <h4 style={{ 
                    color: '#157DEC', 
                    margin: '0 0 8px 0',
                    fontSize: '13px',
                    fontWeight: 'bold'
                  }}>
                    Password Requirements:
                  </h4>
                  <div style={{ 
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: '0',
                    color: '#333',
                    fontSize: '11px',
                    lineHeight: '1.4'
                  }}>
                    <ul style={{ margin: '0', paddingLeft: '18px' }}>
                      <li>At least 8 characters long</li>
                      <li>Mix of upper and lowercase</li>
                    </ul>
                    <ul style={{ margin: '0', paddingLeft: '18px' }}>
                      <li>At least one number</li>
                      <li>Special character (!@#$%^&*)</li>
                    </ul>
                  </div>
                </div>

                <label style={{
                  display: 'block',
                  color: '#2d3748',
                  fontWeight: 'bold',
                  marginBottom: '3px',
                  fontSize: '11px'
                }}>
                  Create Password *
                </label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Create a secure password"
                  minLength="8"
                  required
                  style={{
                    width: '100%',
                    padding: '8px',
                    border: '2px solid black',
                    borderRadius: '5px',
                    fontSize: '12px',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div style={{ margin: '10px 0' }}>
                <label style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: '6px',
                  cursor: 'pointer',
                  fontSize: '11px'
                }}>
                  <input
                    type="checkbox"
                    name="acceptedTerms"
                    checked={formData.acceptedTerms}
                    onChange={handleInputChange}
                    required
                    style={{ marginTop: '2px' }}
                  />
                  I accept the <a href="/Terms and Conditions (August 2025).pdf" target="_blank" style={{ color: '#157DEC', textDecoration: 'underline' }}>Terms and Conditions</a>
                </label>
              </div>

              <button 
                onClick={handleRegistrationSubmit} 
                style={{
                  width: '100%',
                  padding: '10px 20px',
                  fontSize: '12px',
                  background: '#157DEC',
                  color: 'white',
                  border: '2px solid black',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                Click to Create Your Account
              </button>
            </div>
          )}

          
        </div>

        {/* Footer */}
        <div style={{
          gridArea: 'footer',
          textAlign: 'center',
          color: 'white',
          fontSize: '10px',
          lineHeight: '1.2'
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '15px',
            marginBottom: '3px'
          }}>
            <a href="/Privacy Policy (August 2025).pdf" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'underline' }}>Privacy Policy</a>
            <a href="/Terms and Conditions (August 2025).pdf" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'underline' }}>T's and C's</a>
            <a href="/Cookies Policy (August 2025).pdf" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'underline' }}>Cookies Policy</a>
            <a href="https://wa.me/447874401497" target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'underline' }}>Contact</a>
            <a href="mailto:support@btlcc.co.uk" style={{ color: 'white', textDecoration: 'underline' }}>Support</a>
          </div>
          <p style={{ margin: '0 0 2px 0' }}>
            © 2025 The Buy to Let Calculator Company Ltd. All rights reserved.
          </p>
          <p style={{ margin: '0', fontSize: '9px' }}>
            Registered in England & Wales (Company No: 16671121). Registered Office: 73 Barton St, GL20 5PY. ICO Registration No: ZB971476.
          </p>
        </div>
      </div>
    </div>
  );
};

export default InviteOnlyRegistration;